import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

export interface WantedConfig {
  config_id?: number;
  target_date: string;
  max_requests: number;
  year: number;
  month: number;
  shift_type: string | null;
  group_id?: string;
  created_at?: string;
  updated_at?: string;
  /** 서버에서 제거될 수 있음. 없으면 응답 항목은 모두 활성으로 간주 */
  is_active?: boolean;
}

export function useWantedConfigQuery({
  year,
  month,
  groupId,
  enabled,
  includeInactive = false,
}: {
  year: number | undefined;
  month: number | undefined;
  groupId?: string | null;
  enabled?: boolean;
  /** true면 비활성 포함 전체 조회(캘린더 복원용). 기본은 활성만 */
  includeInactive?: boolean;
}) {
  return useQuery({
    queryKey: [
      ...QUERY_KEYS.wanted.config(
        year as number,
        month as number,
        groupId ?? ""
      ),
      includeInactive,
    ],
    queryFn: async () => {
      if (!year || !month) return [];
      const params: {
        year: number;
        month: number;
        group_id?: string;
        include_inactive?: string;
      } = {
        year,
        month,
        include_inactive: includeInactive ? "true" : "false",
      };
      if (groupId) params.group_id = groupId;
      return await httpClient.get<WantedConfig[]>(`/wanted/config`, { params });
    },
    enabled: enabled !== false && !!year && !!month,
    staleTime: 1000 * 60 * 5, // 5분간 캐시
  });
}
